import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import BrandTeaserLogo from '/components/brandTeaserLogo';

function SponsoredByBrand(props) {
  const { sponsor } = props;
  return (
    <Grid item style={{ display: 'flex', marginTop: 4 }}>
        {sponsor != null ?
            <>
            <Typography variant="caption" style={{marginRight: 8, color: '#fff'}}>
                Sponsored by
            </Typography> 
            <BrandTeaserLogo brandTeaserLogo={sponsor.logo} brandSlug={sponsor.slug} />
            </>                     
            : null} 
    </Grid>
  );
}


export default SponsoredByBrand;
